import { RawInputData, TransformedTableData } from "types/tableConversion.types"
import { createEmptyTransformedData } from "utils/tableConversion/tableConversionHelpers"
import { detectDataFormat } from "utils/tableConversion/dataFormatDetector"
import { convertDTABToChart } from "utils/tableConversion/converters/dtabConverter"
import { convertXTABSimpleToChart } from "utils/tableConversion/converters/xtabSimpleConverter"
import { convertXTABMultiToChart } from "utils/tableConversion/converters/xtabMultiConverter"

// Re-export types for backward compatibility
export type {
  BarChartDataItem,
  PieChartSlice,
  PieChartStatisticGroup,
  TransformedTableData,
} from "types/tableConversion.types"

/**
 * Enhanced convertDataToTable function that handles DTAB, XTAB_SIMPLE, and XTAB_MULTI formats
 * Now includes special handling for null category edge cases
 */
export const convertDataToTable = (
  data: RawInputData | null | undefined
): TransformedTableData => {
  if (!data || !Array.isArray(data.data) || data.data.length === 0) {
    return createEmptyTransformedData()
  }

  const dataFormat = detectDataFormat(data)

  switch (dataFormat) {
    case "DTAB":
      return convertDTABToChart(data)
    case "XTAB_SIMPLE":
      return convertXTABSimpleToChart(data)
    case "XTAB_MULTI":
    default:
      return convertXTABMultiToChart(data)
  }
}
